/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the phase of a rollout action notification.
 */
export type RolloutTaskNotificationPhase = 'SCHEDULED' | 'STARTED' | 'COMPLETED' | 'FAILED' | 'CANCELED' | 'RESCHEDULED';

export const RolloutTaskNotificationPhase = {

    SCHEDULED: 'SCHEDULED' as RolloutTaskNotificationPhase,

    STARTED: 'STARTED' as RolloutTaskNotificationPhase,

    COMPLETED: 'COMPLETED' as RolloutTaskNotificationPhase,

    FAILED: 'FAILED' as RolloutTaskNotificationPhase,

    CANCELED: 'CANCELED' as RolloutTaskNotificationPhase,

    RESCHEDULED: 'RESCHEDULED' as RolloutTaskNotificationPhase
};

